"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es6.function.name");
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _ossUpload = require("@/utils/ossUpload");
var _CusromUpload = _interopRequireDefault(require("@/components/uploadImg/CusromUpload.vue"));
var _loginPageConfiguration = require("@/api/appBasicSetup/loginPageConfiguration");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'LoginPageConfiguration',
  components: {
    upload: _CusromUpload.default
  },
  data: function data() {
    // var validateFile = (rule, value, callback) => {
    //   if (value.length === 0) {
    //     callback(new Error('请上传文件'))
    //   } else {
    //     callback()
    //   }
    // }
    return {
      activeName: '1',
      ruleForm: {
        appDescription: '',
        appDescriptionColor: '',
        guideMaps: [],
        appLoginBackgroundImage: '',
        uniConfig: {
          uniStatus: 0,
          // 一键登录开关 0:关 1:开
          uniAppId: '',
          uniProvider: '',
          uniApikey: '',
          uniApiSecret: '',
          privateKey: '',
          oneLoginButtonImage: ''
        },
        wechatLoginConfig: {
          wechatStatus: 0,
          wechatAppId: '',
          wechatUniversalLinks: '',
          wechatAppSecret: ''
        }
      },
      rules: {
        // appDescription: [
        //   { required: true, message: '请填写app描述', trigger: 'blur' }
        // ],
        // appDescriptionColor: [
        //   { required: true, message: '请填写APP描述文字色', trigger: 'blur' }
        // ],
        // guideMaps: [
        //   { required: true, message: '请上传文件引导图', validator: validateFile, trigger: 'change' }
        // ],
        // appLoginBackgroundImage: [
        //   { required: true, message: '请上传app登录页背景图', trigger: 'change' }
        // ],
        'uniConfig.uniStatus': [{
          required: true,
          message: '请选择一键登录状态',
          trigger: 'change'
        }],
        'uniConfig.uniAppId': [{
          required: true,
          message: '请填写UNI-App id',
          trigger: 'blur'
        }],
        'uniConfig.uniProvider': [{
          required: true,
          message: '请填写UNI-Provider',
          trigger: 'blur'
        }],
        'uniConfig.uniApikey': [{
          required: true,
          message: '请填写UNI-Apikey',
          trigger: 'blur'
        }],
        'uniConfig.uniApiSecret': [{
          required: true,
          message: '请填写UNI-Apisecret',
          trigger: 'blur'
        }],
        'wechatLoginConfig.wechatStatus': [{
          required: true,
          message: '请选择微信登录状态',
          trigger: 'change'
        }],
        'wechatLoginConfig.wechatAppId': [{
          required: true,
          message: '请填写微信开放平台 APPID',
          trigger: 'blur'
        }],
        'wechatLoginConfig.wechatUniversalLinks': [{
          required: true,
          message: '请填写微信开放平台 wechatUniversalLinks',
          trigger: 'blur'
        }],
        'wechatLoginConfig.wechatAppSecret': [{
          required: true,
          message: '请填写微信开放平台 wechatAppSecret',
          trigger: 'blur'
        }]
      },
      slid_ruleForm: {
        verifySwitch: 0,
        sceneId: '',
        prefix: '',
        Ekey: '',
        AccessKeyID: '',
        AccessKeySecret: ''
      },
      slid_rules: {
        sceneId: [{
          required: true,
          message: '请填写场景ID',
          trigger: 'blur'
        }],
        prefix: [{
          required: true,
          message: '请填写身份标识',
          trigger: 'blur'
        }],
        Ekey: [{
          required: true,
          message: '请填写Ekey(加密密钥)',
          trigger: 'blur'
        }],
        AccessKeyID: [{
          required: true,
          message: '请填写访问授权ID)',
          trigger: 'blur'
        }],
        AccessKeySecret: [{
          required: true,
          message: '请填写访问授权Secret',
          trigger: 'blur'
        }]
      }
    };
  },
  watch: {
    activeName: function activeName(val) {
      if (val === '1') {
        this.queryLoginPageDetail();
      } else if (val === '2') {
        this.get_slid_config();
      }
    }
  },
  mounted: function mounted() {
    this.queryLoginPageDetail();
  },
  methods: {
    get_slid_config: function get_slid_config() {
      var _this = this;
      (0, _loginPageConfiguration.loadCaptchaConfig)({}).then(function (res) {
        if (res.data && res.data != null) {
          _this.slid_ruleForm.verifySwitch = res.data.verifySwitch ? 1 : 0;
          _this.slid_ruleForm.sceneId = res.data.sceneId;
          _this.slid_ruleForm.prefix = res.data.prefix;
          _this.slid_ruleForm.Ekey = res.data.encryptKey;
          _this.slid_ruleForm.AccessKeyID = res.data.accessKeyId;
          _this.slid_ruleForm.AccessKeySecret = res.data.accessKeySecret;
        }
      });
    },
    handleClick: function handleClick(tab, event) {
      // console.log(tab, event)
    },
    delPic: function delPic() {
      var _this2 = this;
      this.$confirm('确定删除该图片？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this2.$set(_this2.ruleForm.uniConfig, 'oneLoginButtonImage', '');
      }).catch(function () {});
    },
    handleFileUpload: function () {
      var _handleFileUpload = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(file, fileName) {
        var pictureUrl;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return (0, _ossUpload.uploadOSS)(file.file, 'builds', fileName);
            case 1:
              pictureUrl = _context.v;
              console.log(pictureUrl);
              if (pictureUrl) {
                this.$set(this.ruleForm.uniConfig, 'oneLoginButtonImage', pictureUrl);
              }
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function handleFileUpload(_x, _x2) {
        return _handleFileUpload.apply(this, arguments);
      }
      return handleFileUpload;
    }(),
    jump: function jump(val) {
      window.open(val);
    },
    onPictureAddress: function onPictureAddress(data) {
      this.ruleForm[data.name] = data.pictureUrl;
    },
    slid_ruleForm_submitForm: function slid_ruleForm_submitForm(formName) {
      var _this3 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this3.$confirm('当前页配置信息发生修改,是否确认修改内容?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(function () {
            (0, _loginPageConfiguration.saveCaptchaConfig)({
              verifySwitch: _this3.slid_ruleForm.verifySwitch === 1,
              sceneId: _this3.slid_ruleForm.sceneId,
              prefix: _this3.slid_ruleForm.prefix,
              encryptKey: _this3.slid_ruleForm.Ekey,
              accessKeyId: _this3.slid_ruleForm.AccessKeyID,
              accessKeySecret: _this3.slid_ruleForm.AccessKeySecret
            }).then(function (res) {
              if (res.data) {
                _this3.$notify.success({
                  title: '温馨提示',
                  message: '操作成功'
                });
                _this3.get_slid_config();
              }
            });
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    submitForm: function submitForm(formName) {
      var _this4 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this4.$confirm('当前页配置信息发生修改,是否确认修改内容?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(function () {
            _this4.updateLoginPageSettings();
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    copyText: function () {
      var _copyText = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2(text) {
        var _this5 = this;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              try {
                this.$copyText(text).then(function () {
                  _this5.$notify.success({
                    title: '温馨提示',
                    message: '拷贝成功'
                  });
                }).catch(function () {
                  _this5.$notify.success({
                    title: '温馨提示',
                    message: '拷贝失败，请手动复制'
                  });
                });
              } catch (err) {
                alert('拷贝失败，请手动复制');
                this.$notify.success({
                  title: '温馨提示',
                  message: '拷贝失败，请手动复制'
                });
              }
            case 1:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function copyText(_x3) {
        return _copyText.apply(this, arguments);
      }
      return copyText;
    }(),
    handleRemove: function handleRemove(file) {
      var sp_index = '';
      this.ruleForm.guideMaps.map(function (i, index) {
        if (i.url === file.url) {
          sp_index = index;
        }
      });
      this.ruleForm.guideMaps.splice(sp_index, 1);
    },
    handleFileUpload_guideMaps: function () {
      var _handleFileUpload_guideMaps = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3(_ref) {
        var file, pictureUrl, _t;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              file = _ref.file;
              _context3.p = 1;
              _context3.n = 2;
              return (0, _ossUpload.uploadOSS)(file);
            case 2:
              pictureUrl = _context3.v;
              this.ruleForm.guideMaps.push({
                url: pictureUrl
              });
              this.$refs.ruleForm11.validateField('guideMaps');
              _context3.n = 4;
              break;
            case 3:
              _context3.p = 3;
              _t = _context3.v;
              console.log('error ->', _t);
            case 4:
              return _context3.a(2);
          }
        }, _callee3, this, [[1, 3]]);
      }));
      function handleFileUpload_guideMaps(_x4) {
        return _handleFileUpload_guideMaps.apply(this, arguments);
      }
      return handleFileUpload_guideMaps;
    }(),
    updateLoginPageSettings: function () {
      var _updateLoginPageSettings2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee4() {
        var params, res, _t2;
        return (0, _regenerator2.default)().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              params = (0, _objectSpread2.default)({}, this.ruleForm);
              _context4.n = 1;
              return (0, _loginPageConfiguration.updateLoginPageSettings)(params);
            case 1:
              res = _context4.v;
              if (res.code === 0) {
                this.$notify.success({
                  title: '温馨提示',
                  message: '保存成功！'
                });
                this.queryLoginPageDetail();
              }
              _context4.n = 3;
              break;
            case 2:
              _context4.p = 2;
              _t2 = _context4.v;
              console.log(_t2);
            case 3:
              return _context4.a(2);
          }
        }, _callee4, this, [[0, 2]]);
      }));
      function updateLoginPageSettings() {
        return _updateLoginPageSettings2.apply(this, arguments);
      }
      return updateLoginPageSettings;
    }(),
    queryLoginPageDetail: function () {
      var _queryLoginPageDetail2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee5() {
        var params, res, _t3;
        return (0, _regenerator2.default)().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              _context5.p = 0;
              params = {};
              _context5.n = 1;
              return (0, _loginPageConfiguration.queryLoginPageDetail)(params);
            case 1:
              res = _context5.v;
              if (res.code === 0) {
                this.ruleForm = res.data;
                if (!res.data.guideMaps) {
                  this.ruleForm.guideMaps = [];
                }
              }
              _context5.n = 3;
              break;
            case 2:
              _context5.p = 2;
              _t3 = _context5.v;
              console.log(_t3);
            case 3:
              return _context5.a(2);
          }
        }, _callee5, this, [[0, 2]]);
      }));
      function queryLoginPageDetail() {
        return _queryLoginPageDetail2.apply(this, arguments);
      }
      return queryLoginPageDetail;
    }()
  }
};